import React, { memo, useEffect, useMemo, useState } from "react";
import {
  Grid,
  Box,
  Card,
  Typography,
  CardContent,
  Divider,
  TextField,
  InputLabel,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import ModeDeleteIcon from "@mui/icons-material/Delete";
import NoCellIcon from "@mui/icons-material/NoCell";
import classes from "./index.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import {
  getUserList,
  updateDetailsByCaseload,
  addOtherParentById,
  updateOtherParentById,
  getCaseloadById,
  deleteAdditonalParent,
  updateOverViewParent,
  clearUnmountData,
} from "../../../redux/action";
import { useLocation } from "react-router-dom";
import atoms from "../../atoms";
import { useFormik } from "formik";
import * as Yup from "yup";
import { style } from "./style";
import constant from "../../../constants/constant";
import { CurrentUserData, ReferralCaseLoad } from "./interface";
import ConfirmationModal from "../../atoms/ConfirmationModal";
import MarkPrimaryParentSwitch from "../MarkPrimaryParentSwitch";
import AssignSechool from "../AssignSechool";

const { Button, Modal, Select, Table, LightBox, Slider } = atoms;

const OverviewCaseload = ({
  existingEmails,
  referralCaseload,
  isRejected,
  rejectedStyles,
}: any) => {
  const referralReducers = (state: any) => state;

  const statusReducer = createSelector(referralReducers, (state) => ({
    refClosedStatus: state.refClosedReducer,
  }));
  const { refClosedStatus } = useSelector(statusReducer);
  const dispatch = useDispatch();
  const location: any = useLocation();
  const { pathname } = location;
  const parts = pathname?.split("/");
  const firstSegment = parts[1];
  const [isDeleteTask, setisDeleteTask] = React.useState(false);
  const [isNewSchool, setisNewSchool] = React.useState(false);
  const [isDeleteId, setisDeleteId] = React.useState();
  const [IsAddParentFlag, setIsAddParentFlag] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const caseloadId: any = queryParams.get("id");
  const [isMode, setIsMode] = useState<any>();
  const [key, setKey] = useState(0);
  const [isAddClinicianModel, setIsAddClinicianModel] = useState(false);
  const [parentType, setParentType] = useState("");
  const [isSeletedClinician, setIsSeletedClinician] = useState([]);
  const [selectClinicianList, setSelectClinicianList] = useState([]);
  const [isEditParentDetail, setIsEditParentDetail] = useState(false);
  const [digital_literacy, setdigital_literacy] = useState();
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [isNewParentDetail, setIsNewParentDetail] = useState<any>();
  const [additional_parent_carers_details, setadditionalParentDetail] =
    useState<any>({});


 
  const columns = [
    {
      name: "#",
      cell: (item: any, ind: number) => <span>{ind + 1}</span>,
      width: "50px",
    },
    {
      name: "Clinicians Name",
      cell: (item: any, ind: number) => <span>{item.label}</span>,
      sortable: false,
      minWidth: "32%",
    },
    {
      name: "Email Address",
      cell: (item: any, ind: number) => <span>{item.email}</span>,
      sortable: false,
      minWidth: "32%",
    },
    {
      name: "Job Role",
      cell: (item: any, ind: number) => <span>{item.jobRole}</span>,
      sortable: false,
      minWidth: "32%",
    },
  ];

  const userLoggedData: CurrentUserData | null = JSON.parse(
    localStorage.getItem("loginResponse") || "null"
  );

  const userReducer = (state: any) => state?.userManagementReducer;

  const getCustomDropdown = (response: any, name: string, last: string) => {
    let dropdown: any = [];
    response &&
      response?.forEach((value: any) => {
        dropdown.push({
          value: value.id,
          label: last ? value[name] + " " + value[last] : value[name],
          email: value.email,
          jobRole: value.jobRole,
          phone_no: value.phone_no,
        });
      });
    return dropdown;
  };

  const userData = createSelector(userReducer, (state) => ({
    userList: getCustomDropdown(
      state?.userData?.user,
      "first_name",
      "last_name"
    ),
  }));

  const { userList } = useSelector(userData);

  useEffect(() => {
    if (!referralCaseload) return;
    const {
      parent_detail,
      isNewSchool,
      additional_parent_carers_details,
      digital_literacy
    } = referralCaseload;

    const parentValues = {
      first_name: parent_detail?.first_name,
      last_name: parent_detail?.last_name,
      email: parent_detail?.email,
      phone_no: parent_detail?.contact_phone || parent_detail?.phone_no,
      isNewSchool: isNewSchool,
    };
    if (firstSegment === "manage-caseload") {
      setSelectClinicianList(referralCaseload?.clinicialDetails);
      setIsSeletedClinician(referralCaseload?.clinicialDetails);
    }
    setisNewSchool(isNewSchool);
    setIsNewParentDetail(parent_detail);
    setadditionalParentDetail(additional_parent_carers_details);
    setdigital_literacy(digital_literacy);
    validationParent.setValues(parentValues);
    //eslint-disable-next-line
  }, [referralCaseload]);

  const validationParent = useFormik<ReferralCaseLoad>({
    enableReinitialize: true,
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      postCode: "",
      phone_no: "",
      role: constant.ROLE.ALL_ACCESS,
      scope: constant.SCOPE.CLINICIAN,
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("Please Enter First Name"),
      last_name: Yup.string().required("Please Enter Last Name"),
      email: Yup.string()
        .email("Invalid email")
        .test("unique-email", "Email already exists", function (value) {
          return !existingEmails?.includes(value?.toLowerCase());
        })
        .required("Email is required"),
      phone_no: Yup.number(),
    }),
    onSubmit: (values: ReferralCaseLoad) => {
      setIsNewParentDetail(values);
      let payload = {
        parent_detail: values,
        isNewSchool: isNewSchool,
      };

      setIsEditParentDetail(false);
      if (!IsAddParentFlag) {
        if (payload.parent_detail.role === constant.ROLE.ALL_ACCESS) {
          if (payload?.parent_detail?.id) {
            const propertiesToRemove = ["id", "scope", "role", "status"];
            const cleanedValues = Object.fromEntries(
              Object.entries(values).filter(
                ([key]) => !propertiesToRemove.includes(key)
              )
            );
            dispatch(
              updateOverViewParent(
                caseloadId,
                payload?.parent_detail?.id,
                cleanedValues
              )
            );
          }
        } else if (
          payload.parent_detail.role === constant.ROLE.RESTRICTED_ACCESS
        ) {
          payload.parent_detail = {
            ...payload.parent_detail,
            jobRole: "test",
          };
          const { status, role, scope, ...updatedParentDetail } =
            payload.parent_detail;
          payload.parent_detail = updatedParentDetail;
          dispatch(
            updateOtherParentById(updatedParentDetail, updatedParentDetail)
          );
          setTimeout(() => {
            dispatch(getCaseloadById(caseloadId));
          }, 2100);
          dispatch(clearUnmountData());
        }
      } else {
        let { isNewSchool, ...updatedParentDetail } = payload.parent_detail;
        dispatch(addOtherParentById(updatedParentDetail));
        setTimeout(() => {
          dispatch(getCaseloadById(caseloadId));
        }, 2100);
        dispatch(clearUnmountData());
      }
    },
  });

  const addClinician = () => {
    let tempClinicianList: any = [];
    let tempClinicianIds: any = [];
    if (isSeletedClinician) {
      tempClinicianList = tempClinicianList.concat(isSeletedClinician);
    }

    let Ids = isSeletedClinician?.map((item: any) => item?.value);
    if (Ids) {
      tempClinicianIds = tempClinicianIds.concat(Ids);
    }
    tempClinicianIds.filter(
      (v: any, i: any, a: any) => a.findIndex((v2: string) => v2 === v) === i
    );
    tempClinicianList.filter(
      (v: any, i: any, a: any) =>
        a.findIndex((v2: any) => v2.value === v.value) === i
    );
    setSelectClinicianList(tempClinicianList);
    setIsAddClinicianModel(false);
    let payload = {
      clinician_ids: tempClinicianIds,
      isNewSchool: isNewSchool,
    };
    dispatch(updateDetailsByCaseload(caseloadId, payload));
  };

  const handleDeleteParent = (id: any) => {
    dispatch(deleteAdditonalParent(caseloadId, id));
    setKey((prevKey) => prevKey + 1);
    setisDeleteTask(false);
  };

  const sliderContent = useMemo(() => {
    return (
      <Slider
        key={key}
        showStatus={false}
        selectedItem={activeSlideIndex}
        setActiveSlideIndex={setActiveSlideIndex}
        showIndicators={
          additional_parent_carers_details.length !== 0 ? true : false
        }
        showArrows={
          additional_parent_carers_details.length !== 0 ? true : false
        }
      >
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            className={classes.clTitle}
          >
            <Typography variant="h6">1. Parent/Carer Details </Typography>

            {!refClosedStatus &&
              constant.SCOPE.CLINICIAN !== userLoggedData?.scope && (
                <Box>
                  {digital_literacy === false && (
                    <NoCellIcon
                      sx={{
                        cursor: "pointer",
                        color: "#6A2382",
                        marginRight: "1rem",
                      }}
                    />
                  )}
                  <AddCircleIcon
                    onClick={() => {
                      validationParent.resetForm();
                      validationParent.setValues((prevValues) => ({
                        ...prevValues,
                        role: constant.ROLE.RESTRICTED_ACCESS,
                        isAdditionalParent: true,
                        caseload_id: caseloadId,
                        jobRole: "",
                        scope: constant.SCOPE.PARENT,
                        first_name: "",
                        last_name: "",
                        email: "",
                        postCode: "",
                        phone_no: "",
                      }));
                      setIsAddParentFlag(true);
                      setParentType("");
                      setIsEditParentDetail(true);
                    }}
                    sx={{
                      cursor: "pointer",
                      marginRight: "1rem",
                      ...rejectedStyles,
                    }}
                  />
                  <ModeEditIcon
                    onClick={() => {
                      validationParent.resetForm();
                      setIsMode(isNewParentDetail);
                      setParentType("MAIN");
                      validationParent.setValues(isNewParentDetail);
                      setIsEditParentDetail(true);
                    }}
                    sx={{ cursor: "pointer", ...rejectedStyles }}
                  />
                </Box>
              )}
          </Box>
          {/* <Divider /> */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            my={"5px"}
          >
            <Typography variant="subtitle1">Name : </Typography>
            <Typography sx={style.font_custom_style}>
              {(isNewParentDetail?.first_name
                ? isNewParentDetail?.first_name
                : "") +
                " " +
                (isNewParentDetail?.last_name
                  ? isNewParentDetail?.last_name
                  : "")}
            </Typography>
          </Box>
          <Divider />
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            my={"5px"}
          >
            <Typography variant="subtitle1">Email : </Typography>
            <Typography sx={style.font_custom_style}>
              {isNewParentDetail?.email}
            </Typography>
          </Box>
          <Divider />
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            my={"5px"}
          >
            <Typography variant="subtitle1">Contact Number : </Typography>
            <Typography sx={style.font_custom_style}>
              {isNewParentDetail?.phone_no}
            </Typography>
          </Box>
        </CardContent>
        {additional_parent_carers_details &&
          additional_parent_carers_details.length !== 0 &&
          additional_parent_carers_details?.map &&
          additional_parent_carers_details.map((item: any, index: number) => (
            <CardContent key={item.id}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                className={classes.clTitle}
              >
                <Typography variant="h6" align="left">
                  {index + 1}. Additional Parent/Carer Details
                  <MarkPrimaryParentSwitch
                    item={item}
                    caseloadId={caseloadId}
                  />
                </Typography>

                <Box sx={{ display: "flex", alignItems: "start" }}>
                  <ModeEditIcon
                    onClick={() => {
                      validationParent.resetForm();
                      validationParent.setValues(item.user);
                      setIsEditParentDetail(true);
                      setIsAddParentFlag(false);
                      setParentType("OTHER");
                      setIsMode(item.user);
                    }}
                    sx={{
                      cursor: "pointer",
                      ...rejectedStyles,
                      marginRight: "1rem",
                    }}
                  />
                  <ModeDeleteIcon
                    onClick={() => {
                      setisDeleteTask(true);
                      setisDeleteId(item?.user.id);
                      // handleDeleteParent(item?.user.id)
                    }}
                    sx={{
                      cursor: "pointer",
                      ...rejectedStyles,
                      marginRight: "10px",
                    }}
                  />
                </Box>
              </Box>
              <Divider />
              <Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  my={"5px"}
                >
                  <Typography variant="subtitle1">Name : </Typography>
                  <Typography sx={style.font_custom_style}>
                    {(item?.user?.first_name ? item?.user?.first_name : "") +
                      " " +
                      (item?.user?.last_name ? item?.user?.last_name : "")}
                  </Typography>
                </Box>
                <Divider />
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  my={"5px"}
                >
                  <Typography variant="subtitle1">Email : </Typography>
                  <Typography sx={style.font_custom_style}>
                    {item?.user?.email}
                  </Typography>
                </Box>
                <Divider />
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  my={"5px"}
                >
                  <Typography variant="subtitle1">Contact Number : </Typography>
                  <Typography sx={style.font_custom_style}>
                    {item?.user?.phone_no === "" ? "-" : item?.user?.phone_no}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          ))}
      </Slider>
    );
    // eslint-disable-next-line
  }, [
    key,
    activeSlideIndex,
    additional_parent_carers_details,
    isNewParentDetail,
    userLoggedData,
  ]);

  const clinicianDetails = useMemo(() => {
    return (
      <Card variant="outlined" sx={style.card_custom}>
        <CardContent>
          {!refClosedStatus &&
            constant.SCOPE.CLINICIAN !== userLoggedData?.scope && (
              <Grid sx={style.clinicianTab} className="innerheader">
                <Grid>
                  <Typography variant="h6">Assign Clinicians</Typography>
                </Grid>
                <Grid>
                  <Button
                    variant="outlined"
                    className="  btnStyle_v2"
                    startIcon={<AddCircleIcon />}
                    sx={{ borderRadius: "60px" }}
                    disabled={isRejected}
                    onClick={() => {
                      dispatch(
                        getUserList({ scope: constant.SCOPE.CLINICIAN })
                      );
                      setIsAddClinicianModel(true);
                    }}
                  >
                    Add Clinician
                  </Button>
                </Grid>
              </Grid>
            )}
          {!refClosedStatus && <Divider />}
          <Grid sx={style.clinicalTable}>
            <Table
              className={classes.customFixeHeight}
              data={
                selectClinicianList &&
                selectClinicianList?.map((item: any, index: number) => {
                  return {
                    ...item,
                  };
                })
              }
              columns={columns}
            />
          </Grid>
        </CardContent>
      </Card>
    );
    // eslint-disable-next-line
  }, [selectClinicianList, userLoggedData]);

  useEffect(() => {
    setActiveSlideIndex(0);
  }, [additional_parent_carers_details, isNewParentDetail, key]);

  return (
    <Grid className={classes.clWrapper}>
      <Box
        sx={{
          borderRadius: "10px",
          mt: firstSegment !== "manage-caseload" ? 3 : 0,
        }}
      >
        <Grid container columns={12} sx={style.cardGrid}>
          <Grid item xs={12} md={6} sx={{ mb: "1rem!important" }}>
            <Card variant="outlined" sx={style.card_custom}>
              {sliderContent}
            </Card>
          </Grid>

          <Grid item xs={12} md={6} sx={{ mb: "1rem!important" }}>
            <AssignSechool
              existingEmails={existingEmails}
              caseloadId={caseloadId}
              referralCaseload={referralCaseload}
              refClosedStatus={refClosedStatus}
              rejectedStyles={rejectedStyles}
            />
          </Grid>
        </Grid>
        <Grid sx={{ py: { md: "20px" } }}>{clinicianDetails}</Grid>
      </Box>

      <>
        <Modal
          open={isAddClinicianModel}
          handleClose={() => {
            setIsAddClinicianModel(false);
            
          }}
          title={"Add Clinicians"}
        >
          <Box className={classes.clinicModal}>
            <Grid sx={{ width: "100%" }}>
              <Select
                placeholder={
                  isSeletedClinician.length === 0 ? "Select Clinicians" : ""
                }
                onInputChange={(e: any) => e}
                isMulti={true}
                disableCloseOnSelect={true}
                label={"Clinicians"}
                defaultValue={isSeletedClinician}
                options={userList}
                onChange={(e: any) => setIsSeletedClinician(e)}
              />
            </Grid>
            <Grid className={classes.btnWrapper} sx={style.addBtnWrapper}>
              <Button variant={"contained"} onClick={() => addClinician()}>
                Add Clinicians
              </Button>
            </Grid>
          </Box>
        </Modal>
      </>

      <>
        {
          <LightBox
            title={
              IsAddParentFlag
                ? "Add Additional Parent"
                : parentType === "MAIN"
                ? "Edit Parent Details"
                : parentType === "OTHER"
                ? "Edit Additional Parent Details"
                : "Assign Parent"
            }
            open={isEditParentDetail}
            handleClose={() => {
              validationParent.resetForm();
              setIsEditParentDetail(false);
              setIsAddParentFlag(false);
            }}
          >
            <Box className={classes.clinicModal}>
              <Grid sx={{ width: "100%", textAlign: "center" }}></Grid>
              <Grid className={classes.btnWrapper} sx={{ p: "" }}>
                <Grid>
                  <form onSubmit={validationParent.handleSubmit}>
                    <Grid container spacing={3} className={classes.mt_3}>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Box>
                          <InputLabel sx={style.label_color}>
                            {" "}
                            First Name{" "}
                            <Typography
                              variant="body2"
                              component={"span"}
                              sx={{ color: "#d32f2f", fontWeight: "600" }}
                            >
                              *
                            </Typography>
                          </InputLabel>
                          <TextField
                            fullWidth
                            placeholder="Enter First Name"
                            {...validationParent.getFieldProps("first_name")}
                            error={
                              validationParent.touched.first_name &&
                              Boolean(validationParent.errors.first_name)
                            }
                            helperText={
                              validationParent.touched.first_name
                                ? validationParent.errors.first_name
                                : ""
                            }
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Box>
                          <InputLabel sx={style.label_color}>
                            {" "}
                            Last Name{" "}
                            <Typography
                              variant="body2"
                              component={"span"}
                              sx={{ color: "#d32f2f", fontWeight: "600" }}
                            >
                              *
                            </Typography>
                          </InputLabel>
                          <TextField
                            fullWidth
                            placeholder="Enter Last Name"
                            {...validationParent.getFieldProps("last_name")}
                            error={
                              validationParent.touched.last_name &&
                              Boolean(validationParent.errors.last_name)
                            }
                            helperText={
                              validationParent.touched.last_name &&
                              validationParent.errors.last_name
                            }
                          />
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3} className={classes.mt_3}>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Box>
                          <InputLabel sx={style.label_color}>
                            Email{" "}
                            <Typography
                              variant="body2"
                              component={"span"}
                              sx={{ color: "#d32f2f", fontWeight: "600" }}
                            >
                              *
                            </Typography>
                          </InputLabel>
                          <TextField
                            fullWidth
                            type={"email"}
                            disabled={
                              !IsAddParentFlag &&
                              isMode?.status === constant.STATUS.ACTIVE
                            }
                            placeholder="Enter Email"
                            {...validationParent.getFieldProps("email")}
                            error={
                              validationParent.touched.email &&
                              Boolean(validationParent.errors.email)
                            }
                            helperText={
                              validationParent.touched.email &&
                              validationParent.errors.email
                            }
                          />
                          {!IsAddParentFlag &&
                            isMode?.status === constant.STATUS.ACTIVE && (
                              <Box sx={{ color: "#6A2382", fontSize: "14px" }}>
                                User Already Registered
                              </Box>
                            )}
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Box>
                          <InputLabel sx={style.label_color}>Mobile</InputLabel>
                          <TextField
                            fullWidth
                            type="number"
                            placeholder="Enter mobile"
                            {...validationParent.getFieldProps("phone_no")}
                            error={
                              validationParent.touched.phone_no &&
                              Boolean(validationParent.errors.phone_no)
                            }
                            helperText={
                              validationParent.touched.phone_no &&
                              validationParent.errors.phone_no
                            }
                          />
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid
                      className={`${classes.btnClr}`}
                      sx={{ mt: "30px", textAlign: "center" }}
                    >
                      <Button
                        type={"submit"}
                        fullWidth={false}
                        variant={"contained"}
                      >
                        {parentType === "MAIN" || parentType === "OTHER"
                          ? "Edit"
                          : "Assign"}
                      </Button>
                    </Grid>
                  </form>
                </Grid>
              </Grid>
            </Box>
          </LightBox>
        }
      </>


      {isDeleteTask && (
        <ConfirmationModal
          open={isDeleteTask}
          handleClose={() => setisDeleteTask(false)}
          title="Confirmation"
          message="Are you sure you want to delete additional Parent ?"
          onConfirm={() => handleDeleteParent(isDeleteId)}
          onCancel={() => setisDeleteTask(false)}
        />
      )}
    </Grid>
  );
};

export default memo(OverviewCaseload);
